import Modal from 'bootstrap/js/src/modal';

export function init() {

  const modals = document.querySelectorAll('[data-modal]');

  modals.forEach((m) => new CustomModal(m));
}

class CustomModal {
  constructor(node) {
    this.node = node;
    this.modal = new Modal(this.node);
    this.type = node.dataset.modal;
    this.sessionKey = 'hide_modal';
    this.hasSession = sessionStorage.getItem(this.sessionKey);

    this.id = node.id;
    this.trigger = null;

    if (this.id) {
      this.trigger = document.querySelector(`[data-bs-target="#${this.id}"]`);
    }

    this.handleHidden = this.handleHidden.bind(this);
    this.handleShown = this.handleShown.bind(this);
    this.node.addEventListener('hidden.bs.modal', this.handleHidden);
    this.node.addEventListener('shown.bs.modal', this.handleShown);

    this.redirectTrigger = this.node.querySelector('[data-modal-redirect]');
    if (this.redirectTrigger) {
      const { location } = this.redirectTrigger.dataset;
      if (location) {
        this.handleRedirect = this.handleRedirect.bind(this);
        this.redirectTrigger.addEventListener('click', () => this.handleRedirect(location));
      }
    }

    this.init();
  }

  init() {
    if (this.hasSession) {
      if (this.trigger) {
        setTimeout(() => {
          this.trigger.classList.remove('is-hidden');
        }, 1500);
      }
      return;
    }

    this.modal.show();
  }

  handleShown() {
    if (this.trigger) {
      this.trigger.classList.add('is-hidden');
    }
  }

  handleRedirect(location) {
    sessionStorage.setItem(this.sessionKey, true);
    this.modal.hide();
    if (location) {
      window.location.href = location;
    }
  }

  handleHidden() {
    sessionStorage.setItem(this.sessionKey, true);
    if (this.trigger) {
      this.trigger.classList.remove('is-hidden');
    }
  }
}





// WEBPACK FOOTER //
// ./scripts/modules/modals.js